@if (Error) {
  <mj-empty-state Variant="error" Title="Couldn't load your presentation" [Message]="Error"><div actions><button type="button" mjButton variant="primary" (click)="Refresh()">Try again</button></div></mj-empty-state>
} @else if (NoSeason) {
  <mj-empty-state Variant="empty" Title="OEP is between seasons" Message="There is no active OEP season yet. We will email you when your role opens." />
} @else if (NoPresentation) {
  <mj-empty-state Variant="empty" Title="No presentation this season" Message="If you expected one, reply to your OEP email or write to membership@agu.org." />
} @else if (VM) {
<section class="oep-pres" [attr.aria-busy]="Busy">
  <!-- markup.html:302-303 -->
  <h1 class="oep-h1">Your presentation</h1>
  <p class="oep-lead">{{ VM.Intro }}</p>

  <!-- markup.html:305-361 -->
  <div class="oep-card oep-pres__card">
    <div class="oep-row">
      <div class="oep-pres__head">
        <span class="oep-eyebrow">{{ VM.Eyebrow }}</span>
        <h2 class="oep-pres__title">{{ VM.Title }}</h2>
      </div>
      <span class="oep-badge" [attr.data-tone]="VM.DraftStatus.Tone">{{ VM.DraftStatus.Label }}</span>
    </div>

    @if (VM.HeadStart; as h) {
      <div class="oep-pres__box oep-pres__box--sunken">
        <strong class="oep-pres__box-title">Get a head start</strong>
        <p class="oep-pres__box-text">{{ h.Text }}</p>
        @if (h.Links.length) {
          <ul class="oep-pres__links">
            @for (l of h.Links; track l.Url) { <li><a [href]="l.Url" target="_blank" rel="noopener">{{ l.Title }}<span class="oep-sr"> (opens in a new tab)</span></a></li> }
          </ul>
        }
      </div>
    }

    @if (VM.CareerAsk; as c) {
      <div class="oep-pres__box" role="group" aria-labelledby="oep-career-q" aria-describedby="oep-career-note">
        <strong class="oep-pres__box-title" id="oep-career-q">What is your career stage?</strong>
        <div class="oep-pres__box-note" id="oep-career-note">{{ c.Note }}</div>
        <div class="oep-pres__chips">
          @for (s of c.Stages; track s) {
            <button #careerChip type="button" class="oep-pres__chip" [class.oep-pres__chip--on]="c.Chosen === s" [attr.aria-pressed]="c.Chosen === s" [disabled]="Busy" (click)="PickCareer(s)">{{ s }}</button>
          }
        </div>
        <p class="oep-pres__status" role="status" aria-live="polite" [attr.data-tone]="CareerStatus?.Tone">{{ CareerStatus?.Text }}</p>
      </div>
    }

    @if (VM.DraftDrop; as dd) {
      <agu-file-drop class="oep-pres__drop" [Title]="dd.Title" [Note]="dd.Note" [Accept]="Accept" [MaxBytes]="MaxBytes" [Disabled]="dd.Disabled" [Hint]="dd.Hint" [Busy]="Uploading === 'Draft'"
        (FileChosen)="UploadFile('Draft', $event)" (Rejected)="Rejected('Draft', $event)" (BlockedClick)="DraftBlocked()" />
    }

    @if (VM.DraftFile; as f) {
      <div class="oep-pres__file">
        <i class="fa-regular fa-file-lines oep-pres__file-icon" aria-hidden="true"></i>
        <span class="oep-pres__file-body"><span class="oep-pres__file-name">{{ f.Name }}</span><span class="oep-pres__file-detail">{{ f.Detail }}</span></span>
        <button type="button" class="oep-pres__link" (click)="OpenFile('Draft', f.FileID)">View your file</button>
        @if (f.CanReplace && !Replacing.Draft) {
          <button type="button" class="oep-pres__action" [disabled]="Busy" (click)="StartReplace('Draft')">Replace file</button>
        }
      </div>
      @if (Replacing.Draft && f.Replace; as r) {
        <agu-file-drop class="oep-pres__drop oep-pres__drop--replace" [Title]="r.Title" [Note]="r.Note" [Accept]="Accept" [MaxBytes]="MaxBytes" [Busy]="Uploading === 'Draft'"
          (FileChosen)="UploadFile('Draft', $event)" (Rejected)="Rejected('Draft', $event)" />
        <button type="button" class="oep-pres__action oep-pres__cancel" [disabled]="Uploading === 'Draft'" (click)="CancelReplace('Draft')">Keep the current file</button>
      }
      <div class="oep-pres__note">{{ f.Note }}</div>
    }

    @if (Uploading === 'Draft') {
      <div class="oep-pres__progress"><progress [value]="Progress ?? 0" max="1" aria-label="Draft upload progress"></progress><span>{{ ProgressLabel() }}</span></div>
    }
    <p class="oep-pres__status" role="status" aria-live="polite" [attr.data-tone]="UploadStatus.Draft?.Tone">{{ UploadStatus.Draft?.Text }}@if (UploadStatus.Draft?.Link; as l) { <a [href]="l.Url" target="_blank" rel="noopener">{{ l.Label }}<span class="oep-sr"> (opens in a new tab)</span></a> }</p>

    @if (VM.ClosedNote) {
      <div class="oep-pres__box oep-pres__box--sunken oep-pres__closed">{{ VM.ClosedNote }}</div>
    }
  </div>

  <!-- markup.html:363-393 -->
  @if (VM.Final; as fin) {
    <div class="oep-card oep-pres__card">
      <div class="oep-row oep-pres__final-head">
        <h2 class="oep-pres__h2">Your final presentation</h2>
        <span class="oep-pres__deadline">{{ fin.DeadlineNote }}</span>
      </div>
      <p class="oep-pres__intro">{{ fin.Intro }}</p>
      @if (fin.Drop; as fd) {
        <agu-file-drop class="oep-pres__drop" [Title]="fd.Title" [Note]="fd.Note" [Accept]="Accept" [MaxBytes]="MaxBytes" [Busy]="Uploading === 'Final'"
          (FileChosen)="UploadFile('Final', $event)" (Rejected)="Rejected('Final', $event)" />
      }
      @if (fin.Missed) {
        <div class="oep-pres__box oep-pres__box--sunken">No final presentation was uploaded before the window closed, so your section committee judged your session from the nomination alone.</div>
      }
      @if (fin.File; as ff) {
        <div class="oep-pres__file">
          <span class="oep-pres__file-body"><span class="oep-pres__file-name">{{ ff.Name }}</span><span class="oep-pres__file-detail">{{ ff.Detail }}</span></span>
          @if (ff.CanReplace && !Replacing.Final) {
            <button type="button" class="oep-pres__action" [disabled]="Busy" (click)="StartReplace('Final')">Replace file</button>
          }
          @if (!ff.CanReplace) {
            <button type="button" class="oep-pres__link" (click)="OpenFile('Final', ff.FileID)">View the file you presented</button>
          }
        </div>
        @if (Replacing.Final && ff.Replace; as r) {
          <agu-file-drop class="oep-pres__drop oep-pres__drop--replace" [Title]="r.Title" [Note]="r.Note" [Accept]="Accept" [MaxBytes]="MaxBytes" [Busy]="Uploading === 'Final'"
            (FileChosen)="UploadFile('Final', $event)" (Rejected)="Rejected('Final', $event)" />
          <button type="button" class="oep-pres__action oep-pres__cancel" [disabled]="Uploading === 'Final'" (click)="CancelReplace('Final')">Keep the current file</button>
        }
      }
      @if (Uploading === 'Final') {
        <div class="oep-pres__progress"><progress [value]="Progress ?? 0" max="1" aria-label="Final upload progress"></progress><span>{{ ProgressLabel() }}</span></div>
      }
      <p class="oep-pres__status" role="status" aria-live="polite" [attr.data-tone]="UploadStatus.Final?.Tone">{{ UploadStatus.Final?.Text }}@if (UploadStatus.Final?.Link; as l) { <a [href]="l.Url" target="_blank" rel="noopener">{{ l.Label }}<span class="oep-sr"> (opens in a new tab)</span></a> }</p>
    </div>
  }

  <!-- markup.html:395-458 -->
  @if (VM.Feedback; as fb) {
    <div class="oep-pres__fb-head">
      <h2 class="oep-pres__h2">Feedback from your reviewers</h2>
      <span class="oep-pres__count">{{ fb.CountLabel }}</span>
    </div>
    <p class="oep-pres__intro">{{ fb.Intro }}</p>
    <div class="oep-pres__reviews">
      @for (f of fb.Items; track f.ReviewID) {
        <article class="oep-card oep-pres__review" [attr.aria-labelledby]="'oep-rv-' + f.ReviewID">
          <div class="oep-pres__review-head">
            <div class="oep-pres__who">
              <h3 class="oep-pres__h3" [id]="'oep-rv-' + f.ReviewID">{{ f.Who }}</h3>
              @if (f.Institution) { <span class="oep-pres__affil">{{ f.Institution }}</span> }
              <span class="oep-pres__of">{{ f.Position }}</span>
            </div>
            <span class="oep-pres__when">{{ f.When }}</span>
          </div>
          <ul class="oep-pres__scores">
            @for (s of f.Scores; track s.Label) {
              <li class="oep-pres__score"><div class="oep-pres__score-top"><strong>{{ s.Label }}</strong><span class="oep-pres__score-value">{{ s.Value }}</span></div><div class="oep-pres__score-text">{{ s.Text }}</div></li>
            }
          </ul>
          <div class="oep-pres__texts">
            <div class="oep-eyebrow">What worked</div>
            <p>{{ f.Strengths }}</p>
            @if (f.Suggestions) {
              <div class="oep-eyebrow">Suggestions before the meeting</div>
              <p>{{ f.Suggestions }}</p>
            }
          </div>

          <div class="oep-pres__block">
            <h4 class="oep-pres__h4" [id]="'oep-wt-' + f.ReviewID">Write to this reviewer</h4>
            <div class="oep-pres__block-note" [id]="'oep-wt-note-' + f.ReviewID">{{ f.ThreadNote }}</div>
            @if (f.Thread.length) {
              <ol class="oep-pres__thread">
                @for (m of f.Thread; track $index) {
                  <li class="oep-pres__bubble" [class.oep-pres__bubble--mine]="m.Mine"><strong>{{ m.Who }}</strong>{{ m.Body }}</li>
                }
              </ol>
            }
            @if (f.CanWrite) {
              <textarea class="oep-textarea oep-pres__textarea" [id]="'oep-wt-text-' + f.ReviewID" [attr.aria-labelledby]="'oep-wt-' + f.ReviewID" [attr.aria-describedby]="'oep-wt-note-' + f.ReviewID"
                [maxlength]="NoteMax" placeholder="Thank you for the point about the methods figure…" [(ngModel)]="Message[f.ReviewID]" [readonly]="Busy" [attr.aria-busy]="Busy"></textarea>
              <button type="button" mjButton variant="primary" class="oep-pres__send" [disabled]="!CanSend(f)" (click)="Send(f)">Send message</button>
            }
            <p class="oep-pres__status" role="status" aria-live="polite" [attr.data-tone]="ThreadStatus[f.ReviewID]?.Tone">{{ ThreadStatus[f.ReviewID]?.Text }}</p>
          </div>

          <div class="oep-pres__block">
            <h4 class="oep-pres__h4" [id]="'oep-ty-' + f.ReviewID">{{ f.ThanksTitle }}</h4>
            <div class="oep-pres__block-note" [id]="'oep-ty-note-' + f.ReviewID">{{ f.ThanksNote }}</div>
            @if (f.CanThank) {
              <textarea class="oep-textarea oep-pres__textarea" [id]="'oep-ty-text-' + f.ReviewID" [attr.aria-labelledby]="'oep-ty-' + f.ReviewID" [attr.aria-describedby]="'oep-ty-note-' + f.ReviewID"
                [maxlength]="NoteMax" placeholder="Thank you for taking the time…" [(ngModel)]="Thanks[f.ReviewID]" [readonly]="Busy" [attr.aria-busy]="Busy"></textarea>
              <button type="button" mjButton variant="outline" class="oep-pres__send" [disabled]="!CanSendThanks(f)" (click)="SendThanks(f)">Send thank you note</button>
            }
            @if (f.ThanksSent) {
              <div class="oep-pres__sent">Thank you note sent ✓</div>
            }
            <p class="oep-pres__status" role="status" aria-live="polite" [attr.data-tone]="ThanksStatus[f.ReviewID]?.Tone">{{ ThanksStatus[f.ReviewID]?.Text }}</p>
          </div>
        </article>
      }
    </div>
  }

  <!-- markup.html:461-468 -->
  @if (VM.Guidance; as gd) {
  <div class="oep-card oep-pres__guidance">
    <div class="oep-pres__guidance-body">
      <span class="oep-eyebrow">Guidance</span>
      <h2 class="oep-pres__guidance-title">{{ gd.Title }}</h2>
      <p>{{ gd.Text }}</p>
    </div>
    <a class="oep-pres__guidance-link" [href]="gd.Link.Url" target="_blank" rel="noopener">Read the guidance<span class="oep-sr"> (opens in a new tab)</span></a>
  </div>
  }

  <!-- markup.html:470-474 -->
  @if (VM.Outcome; as o) {
    <div class="oep-pres__outcome">
      <div class="oep-pres__outcome-eyebrow">Awards</div>
      <h2 class="oep-pres__outcome-title">{{ o.Title }}</h2>
      <p>{{ o.Body }}</p>
    </div>
  }
</section>
}
